import React, { useEffect } from "react"
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from "@mui/material/Box"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// Css file
import "./index.css"
import Typography from "@mui/material/Typography";
import ErrorIcon from '@mui/icons-material/Error';

const LOT_AGE = "lottery-agency"
const SUP_LOT = "provider-lottery"

// ===================== | CONCILIATION MODAL | ===============================

const ConciliationModal = ({ data, setData }) => {
  const {
    supplierLottery,
    lotteryAgency
  } = data.conciliationData

  // Section: Business Logic
  const lotteryAgencyBadStatus = lotteryAgency !== undefined ?
    lotteryAgency.filter((data) => (data.sended.status !== "OK" || data.returned.status !== "OK")) :
    undefined

  const lotteryAgencyRows = lotteryAgencyBadStatus ?
    buildRows(lotteryAgencyBadStatus, LOT_AGE) :
    undefined


  // SUPPLIER
  const supplierLotteryBadStatus = supplierLottery ?
    new Array(supplierLottery).filter((data) => (data.sended.status !== "OK" || data.returned.status !== "OK")) :
    undefined

  const supplierLotteryRows = supplierLotteryBadStatus ?
    buildRows(supplierLotteryBadStatus, SUP_LOT) :
    undefined

  // Section: Modal

  const handleOpen = () => {
    setData((prev) => ({ ...prev, open: false }))
  }

  const descriptionElementRef = React.useRef(null);
  useEffect(() => {
    if (data.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [data.open, descriptionElementRef]);

  // Section: Tab
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      scroll='paper'
      open={data.open}
      onClose={handleOpen}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="title-dialog"
      >
        Error conciliación
        <ErrorIcon color="error" />
      </DialogTitle>
      <DialogContent>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            {lotteryAgencyRows &&
              <Tab label="Lotería - Agencias" {...a11yProps(1)} />
            }
            {supplierLotteryRows &&
              <Tab label="Proveedor - Lotería" {...a11yProps(0)} />
            }
          </Tabs>
        </Box>
        {lotteryAgencyRows &&
          <CustomTabPanel value={value} index={0}>
            <ConciliationTable
              rows={lotteryAgencyRows}
              type={LOT_AGE}
              desc="Detalle de conciliación entre lotería y agencias"
            />
          </CustomTabPanel>
        }
        {supplierLotteryRows &&
          <CustomTabPanel value={value} index={1}>
            <ConciliationTable
              rows={supplierLotteryRows}
              type={SUP_LOT}
              desc="Detalle de conciliación entre proveedor y lotería"
            />
          </CustomTabPanel>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOpen}>Ok</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConciliationModal

// ========================= | AUX FUNCTIONS | =================================

function buildRows(moveData, type) {
  const moveRows = moveData.map((data) => {

    const vtaProv = data.sended.fileQty
    const vtaNoa = data.sended.registeredQty
    const devProv = data.returned.fileQty
    const devNoa = data.returned.registeredQty
    const sendedStatus = data.sended.status
    const returnedStatus = data.returned.status

    if (type === LOT_AGE) {
      const pdv = `${data.agency.number}-${data.agency.subNumber | 0}`
      return { pdv, vtaProv, vtaNoa, devProv, devNoa, sendedStatus, returnedStatus }
    }

    return { vtaProv, vtaNoa, devProv, devNoa, sendedStatus, returnedStatus }

  })

  return moveRows
}

// ======================== | TABS - AUX COM/FUNC | ============================

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// ============================== | TABLE | =====================================

function ConciliationTable(props) {
  const { rows, type, desc } = props

  return (
    <>
      <Typography
        className="desc"
        variant="h6"
      >
        {desc}
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {type === LOT_AGE &&
                <TableCell className="cell-separator">Pdv</TableCell>
              }
              <TableCell align="center">Vta. Prov.</TableCell>
              <TableCell className="cell-separator" align="center">Vta. Noa</TableCell>
              <TableCell align="center">Dev. Prov.</TableCell>
              <TableCell align="center">Dev. Noa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {type === LOT_AGE &&
                  <TableCell
                    className="cell-separator font-bold"
                    component="th"
                    scope="row">{row.pdv}</TableCell>
                }
                <TableCell
                  className={`${row.sendedStatus !== "OK" ? "cell-error" : ""}`}
                  align="center"
                >
                  {row.vtaProv}
                </TableCell>
                <TableCell
                  className={`${row.sendedStatus !== "OK" ? "cell-error" : ""} cell-separator`}
                  align="center"
                >
                  {row.vtaNoa}
                </TableCell>
                <TableCell
                  className={`${row.returnedStatus !== "OK" ? "cell-error" : ""}`}
                  align="center"
                >
                  {row.devProv}
                </TableCell>
                <TableCell
                  className={`${row.returnedStatus !== "OK" ? "cell-error" : ""}`}
                  align="center"
                >
                  {row.devNoa}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
